import { NextUIProvider } from '@nextui-org/react'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import type { FC } from 'react'
import { StrictMode, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import 'swiper/css'
import { CampaignSiteLayout } from '~/components/campaign/CampaignSiteLayout'
import { CurieSelect } from '~/components/common/CurieSelect'
import { TaskParams } from '~/components/task-forms/BaseTaskForm'
import { InputOutputToDWLForm } from '~/components/task-forms/InputOutputToDWLForm'
import { InputOutputExamples } from '~/data/InputOutputExamples'
import { AgentRequest, CommandType } from '~/protos/agents'
import { trace } from '~/services/analyticsService'
import { localStoragePersister as persister, queryClient } from '~/services/queryClient'
import store from '~/store'
import { BetterToast } from '~/utils/toast'

const Page: FC = () => {
  return (
    <CampaignSiteLayout
      title='DataWeave Generator'
      description='Use Generative AI to generate DataWeave from Sample Input and Output Data'
      buttonText='Generate DataWeave'
      instructionsTitle='Try out Curie on the following examples or on your own sample data'
      instructions={
        <ol className='pl-2'>
          <li className='list-decimal list-inside'>
            Choose one of the pre-provided examples below, hit generate and watch Curie write
            DataWeave for you
          </li>
          <li className='list-decimal list-inside'>
            Put in your own sample input data and sample output data, choose the right input format,
            hit generate and watch Curie write DataWeave tailor made for you sample data
          </li>
        </ol>
      }
    ></CampaignSiteLayout>
  )
}

export default Page
